import { configureStore } from '@reduxjs/toolkit';
import authReducer from "../redux/authSlice";
import surveyReducer from "../redux/surveySlice"

export default configureStore({
  reducer: {
    auth: authReducer,
    survey: surveyReducer
  }
});
